import Cookies from 'js-cookie';
import * as RedirectConst from '../const/RedirectConst';

export function getRedirectCookie() {
  return Cookies.getJSON(RedirectConst.cookieName);
}

export function setRedirectCookie(cookieObj) {
  Cookies.set(RedirectConst.cookieName, cookieObj);
}
